import datapoints from '../datapoints';
import Module from '../schema/Module';
import { getHostLocation } from 'owa-url/lib/hostLocation';
import { logUsage } from 'owa-analytics';
import { getCalendarPath, getMailPath, getPeoplePath, getScopedPath } from 'owa-url';
import * as trace from 'owa-trace';
import { isOpx } from 'owa-opx/lib/isOpx';
/**
 * onClick handler for module switcher items
 * @param currentModule current app
 * @param selectedModule selected app
 * @param onActiveModuleClickAction special handler when both current and selected app are same
 */
export default function onModuleSwitcherItemClick(
    currentModule: Module,
    selectedModule: Module,
    onActiveModuleClickAction: () => void
) {
    if (currentModule === selectedModule) {
        onActiveModuleClickAction && onActiveModuleClickAction();
        return;
    }

    const actionUrl = getSelectedModuleUrl(selectedModule);
    if (actionUrl) {
        const { eventName, customData } = datapoints.ModuleSwitch.datapoint;
        logUsage(eventName, customData(currentModule.toString(), selectedModule.toString()));
        // Navigate to new url in the same tab. This will take relative paths to current origin also
        window.location.assign(actionUrl);
    }
}

export const MODULE_PATH_NAMES = {
    [Module.Mail]: '/mail',
    [Module.Calendar]: '/calendar',
    [Module.People]: '/people',
    [Module.ToDo]: '/todo',
};
const getRootPathMap = {
    [Module.Mail]: getMailPath,
    [Module.Calendar]: getCalendarPath,
    [Module.People]: getPeoplePath,
    [Module.ToDo]: getPeoplePath,
};

/**
 * Generic function to move to shared module
 * TODO: can be moved to shared modules
 * @param selectedModule
 */
export function getPathPrefix(selectedModule: Module) {
    const isOPX = isOpx();
    const searchQuery = getHostLocation().search;
    let pathPrefix;
    if (isOPX) {
        pathPrefix = getScopedPath(MODULE_PATH_NAMES[selectedModule]);
    } else {
        pathPrefix = getRootPathMap[selectedModule]();
    }
    return { searchQuery, pathPrefix };
}

/**
 * Returns the appropriate redirection path for a given module
 * @param selectedModule selected Module
 */
export function getSelectedModuleUrl(selectedModule: Module): string {
    const { searchQuery, pathPrefix } = getPathPrefix(selectedModule);
    switch (selectedModule) {
        case Module.Mail:
            return pathPrefix + searchQuery.replace('&todo=true', '');
        case Module.Calendar:
            return pathPrefix + searchQuery.replace('&todo=true', '');
        case Module.People:
            return pathPrefix + searchQuery.replace('&todo=true', '');
        case Module.ToDo:
            return pathPrefix + searchQuery + (!searchQuery.includes('todo') ? '&todo=true' : '');
        default:
            trace.errorThatWillCauseAlert(`Unknown Module launched ${selectedModule}`);
            return null;
    }
}
